<ion-header>
  <ion-toolbar mode="md">
    <ion-title size="small">
      <ion-text style="font-weight: bold">
        {{ "orderCustomerNotificationsModal.title" | translate }}
      </ion-text>
    </ion-title>
    <ion-buttons slot="end">
      <ion-button color="dark" fill="clear" (click)="closeModal()">
        <ion-icon slot="icon-only" src="assets/ionicons/close.svg"> </ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>
  <ion-list *ngIf="currentUser && currentUser.alertOrder">
    <ion-item lines="none">
      <ion-label class="ion-text-center ion-text-wrap" style="line-height: 1.2">
        <ion-text style="font-weight: bold; font-size: small">
          {{
            "orderCustomerNotificationsModal.select-notifications-for-future-orders"
              | translate
          }}
        </ion-text>
      </ion-label>
    </ion-item>
    <ion-item>
      <ion-label>
        <div>
          {{ "account-settings.by-email" | translate }}
        </div>

        <p
          *ngIf="!currentUser.alertOrder.email && !currentUser.email"
          style="font-size: small"
        >
          <ion-text color="danger">
            {{ "orderCustomerNotificationsModal.no_email_saved" | translate }}
          </ion-text>
        </p>

        <p *ngIf="currentUser.alertOrder.email && currentUser.email">
          <ion-text color="primary">
            {{ currentUser.email }}
          </ion-text>
        </p>
      </ion-label>
      <ion-checkbox
        slot="start"
        [disabled]="currentUser.email ? false : true"
        [(ngModel)]="currentUser.alertOrder.email"
      ></ion-checkbox>
    </ion-item>

    <ion-item>
      <ion-label>
        <div>
          {{ "account-settings.by-push" | translate }}
        </div>
      </ion-label>
      <ion-checkbox
        slot="start"
        [disabled]="pushControlDisabled || pushPermissionLoading || updatingDataLoading"
        [(ngModel)]="currentUser.alertOrder.push"
        (ngModelChange)="onPushChange($event)"
      ></ion-checkbox>
    </ion-item>

    <ion-item>
      <ion-label>
        {{ "account-settings.by-sms" | translate }}

        <p
          *ngIf="currentUser.alertOrder.sms && currentUser.mobile"
          style="font-size: small"
        >
          <ion-text color="primary">
            {{ currentUser.mobile }}
          </ion-text>
        </p>
      </ion-label>
      <ion-checkbox
        slot="start"
        [(ngModel)]="currentUser.alertOrder.sms"
      ></ion-checkbox>
    </ion-item>

    <ion-item lines="none">
      <ion-label class="ion-text-center ion-text-wrap" style="line-height: 1.2">
        <ion-text style="font-weight: bold; font-size: small">
          {{
            "orderCustomerNotificationsModal.you-can-always-change-settings-from-account-settings"
              | translate
          }}
        </ion-text>
      </ion-label>
    </ion-item>
  </ion-list>
</ion-content>

<ion-footer>
  <ion-grid>
    <ion-row style="width: 100%">
      <ion-col size="12" class="ion-text-center">
        <ion-button
          [disabled]="updatingDataLoading || pushPermissionLoading"
          (click)="saveCustomerPreferences()"
        >
          <ion-text *ngIf="!updatingDataLoading">
            {{ "orderCustomerNotificationsModal.save" | translate }}
          </ion-text>

          <ion-spinner *ngIf="updatingDataLoading"></ion-spinner>
        </ion-button>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-footer>
